import { render, staticRenderFns } from "./ShowTicketNoStage.vue?vue&type=template&id=1970940e&scoped=true&"
import script from "./ShowTicketNoStage.vue?vue&type=script&lang=js&"
export * from "./ShowTicketNoStage.vue?vue&type=script&lang=js&"
import style0 from "./ShowTicketNoStage.vue?vue&type=style&index=0&id=1970940e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1970940e",
  null
  
)

export default component.exports